// extracted by mini-css-extract-plugin
module.exports =  {"week-label":"WeekLabel-l0m___week-label","week-number":"WeekLabel-nHXA__week-number","week-name":"WeekLabel-oV3E__week-name"};